export default __webpack_public_path__ + "static/media/nfo-n50-banner.c23a71f4.png";